/* TODO: t() */
import React from 'react';
import { StyleSheet, View, ViewProps } from 'react-native';
import { Text } from '../uiold';

type Props = ViewProps & {
  title: string;
  children?: React.ReactNode;
};

function FieldGroup(props: Props) {
  let { title, children, ...otherProps } = props;
  return (
    <View {...otherProps}>
      <View style={styles.groupTitle}>
        <Text style={styles.title}>{title}</Text>
      </View>
      <View style={styles.groupChildren}>{children}</View>
    </View>
  );
}

let styles = StyleSheet.create({
  groupTitle: {
    paddingLeft: 20,
    paddingVertical: 10,
    marginTop: 10,
    marginHorizontal: 10,
    borderWidth: 1,
    borderColor: '#ddd',
    backgroundColor: '#f7f7f7',
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  groupChildren: {
    paddingTop: 5,
    paddingBottom: 10,
    marginBottom: 10,
    marginHorizontal: 10,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 3,
    borderColor: '#ddd',
    borderTopWidth: 0,
  },
  title: {
    fontWeight: '600',
    color: '#767676',
  },
});

export default FieldGroup;
